<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX1860oHSM/7gN6BVYMH26pZ3x1iW8ORsIlw=","cpf":"U2FsdGVkX1//a9S+ICa9fEtSUeVAIcMdXbuwVXdXIWI="},{"num_cand":"U2FsdGVkX192Nd8k/4fFJq/6N8lFb7VigWd8+C9D7uI=","cpf":"U2FsdGVkX19cNIEqLFj2lGjV30rZVpo/U02RONKB8J4="},{"num_cand":"U2FsdGVkX1+JQmx25K4Z6ybVQrL85FB5VQ8K6pTMOCk=","cpf":"U2FsdGVkX19qUVr/HwxmB34OCcXzrp2+1VgofOw+/o8="},{"num_cand":"U2FsdGVkX19I72nvGh8mPo4qsUxNvjPiMEHe1t4z3IM=","cpf":"U2FsdGVkX1+vAQbmXZOoj4IHkF/mnAaduHyyyxJhuwE="},{"num_cand":"U2FsdGVkX1/XrNAudv9SjCrlfwwgDgI6G9Id+dXfhx4=","cpf":"U2FsdGVkX1+fX1IITr4xy+hoYED/Uz8fN9f+S15EMnA="},{"num_cand":"U2FsdGVkX198o6+amoPuWS/LKKFiADRdyRELqu6oo9w=","cpf":"U2FsdGVkX1+3rmIyNme6UGAo3RVKQ4RFgGY4/PzdZtE="},{"num_cand":"U2FsdGVkX1/Aa/Qtic1u8ezF1yZ4tJDnnbc8Sk1hJQ4=","cpf":"U2FsdGVkX19OOz3zDaEythnpcRkBjpB0gZ8+tzYnpmg="},{"num_cand":"U2FsdGVkX1+YxvakJvnQx1NX6yXh4raO/FjCfl1xmrU=","cpf":"U2FsdGVkX1+oa1JvXymh+zvByaCRozwVvMBYBIfL1IQ="},{"num_cand":"U2FsdGVkX189i7C+8Teri8+DV/kVYZRlZKVbw+ovJpc=","cpf":"U2FsdGVkX18XUZrGwa3/ufzsU62d3qa57huDgh4cMLA="},{"num_cand":"U2FsdGVkX18JMXI19rsbwi+axrlIxxgwrDd13RJlWys=","cpf":"U2FsdGVkX19PKNUn6/HkkoT7Ht1Spn6akKwjEfF535E="},{"num_cand":"U2FsdGVkX1/VqFqfLFCSaB6Z+837A9LaZtiBfHc/XrI=","cpf":"U2FsdGVkX18naxEhCDKZbWknAsm/rfpwsVwAdBWVsGU="},{"num_cand":"U2FsdGVkX19Hllj1D/5BUIOGTOgzq8Am7Qb7qgkslqo=","cpf":"U2FsdGVkX1/CVFA5Sm6FoJgbXRmdRB0H2yU5mMD+/go="},{"num_cand":"U2FsdGVkX1/Yl7Fk4TZ2uyYwxryNRPg62EE4FS1EO0c=","cpf":"U2FsdGVkX18zx1Tm4FG0poJlNGk6zWSgFwY7Mt2GdI0="},{"num_cand":"U2FsdGVkX1+x4cniIi26xUS25ho1PPcsaAQi6Ag3NDM=","cpf":"U2FsdGVkX1+uf64FlXNk1z/PZhsstaTtiUum8aLuED0="},{"num_cand":"U2FsdGVkX1/2GHni+yrnF+QZtSx5FYSN63g5gleQoes=","cpf":"U2FsdGVkX1/SUYhI4pizGfYLDKwXUKDnAQJ6rpeUOkc="},{"num_cand":"U2FsdGVkX18Yg9TyX2Eo+nXaWtcIJT3V6xbjTzh9qMs=","cpf":"U2FsdGVkX19GkaohHLbaXPuv/D62D4WxdfL6+GlGaXM="},{"num_cand":"U2FsdGVkX1+0jX8fIPQczNvtuUXGWbJWQU4JRGse0JQ=","cpf":"U2FsdGVkX1/V4ibIC6BaeVwi90SAfMMl5n/WAALHYZg="},{"num_cand":"U2FsdGVkX1+N+cE7diDyeX9NSkokUcvXWNPHahMWt8c=","cpf":"U2FsdGVkX19RXHcoyVtCdI7hkyVRevRjW8u12/lIw3c="},{"num_cand":"U2FsdGVkX18eQQvblqnx+dG01g91KJSSEkIJiU5YIkE=","cpf":"U2FsdGVkX1+Ie8mIsGBkojeauBkWclFGMSTh7AX35dg="},{"num_cand":"U2FsdGVkX1+WjJwFmSUy+OVGXU25n3HskaAMdVePtjg=","cpf":"U2FsdGVkX1/zH3HSD7bGCQEkjE8uMIw/EnnkYMSRh5g="},{"num_cand":"U2FsdGVkX1/vydGYBnqem8khfSZ9+XYc3SIgXPrS5bk=","cpf":"U2FsdGVkX1/I7QHjsCr1Nq33HtCPVipFag+mRjSPPJQ="},{"num_cand":"U2FsdGVkX1+72nBaGecX5zDIA3Rjp9KC9f812i9mV7M=","cpf":"U2FsdGVkX19uSchKY9ow5P0pnLgkwOPEiWRHFU45WtU="},{"num_cand":"U2FsdGVkX19OnNgplojo+Su2kngxUFsceZru4+CjBPs=","cpf":"U2FsdGVkX19ZTBNSujGH2cDnoZR2QA4hrIoXuGlQoBg="},{"num_cand":"U2FsdGVkX1/0znhXXG91JyjbPwSEAtJT7g6IYQ16Xpk=","cpf":"U2FsdGVkX1/GZMsVBQwsEtMk4lD/dUbBiH9ntpQgGQE="},{"num_cand":"U2FsdGVkX1/frGcoF2+kFNr64VR5agXrfxwnjiF0xxE=","cpf":"U2FsdGVkX189vYwhNjvWITH7opxTBrZx/5JDgus4ylY="},{"num_cand":"U2FsdGVkX1+1BJUTJ0f6B3IsKQGr3jxw/Afvpu7+4Og=","cpf":"U2FsdGVkX1+RdXNXB6xHLpm3aCfrIWfreo7bxpEZdOo="},{"num_cand":"U2FsdGVkX1/0AOLmdiUjPxDlwLkGP0D4Aqk8CL0jv10=","cpf":"U2FsdGVkX1+YPOz5HENuvzgLxraHfdqR9TM1O9r2qb4="},{"num_cand":"U2FsdGVkX1+n7L2fHIKn98PnaZj+8dtOecB0SMQK+Tk=","cpf":"U2FsdGVkX198rgiBY1PCqir4fPctri8dch1eZmRornI="},{"num_cand":"U2FsdGVkX1+l0mGJClt9qn6hGgEC5HjcMWfbUvg0Yl4=","cpf":"U2FsdGVkX19XnnEK9lnLK34boBgJbyZ8zrB5J6Ainc4="},{"num_cand":"U2FsdGVkX1+dg0w/kECmRiijXl9iFeVGuvV2oiZiNMU=","cpf":"U2FsdGVkX1+L11YTsL6zw1gxDGlqeEJYEzc6wPPTSuQ="},{"num_cand":"U2FsdGVkX18l2M3l2/0DUbYo3t7KtStRLWYFh4fri9g=","cpf":"U2FsdGVkX19C8wrGSlDQHUbykb2ZYa+zvUTaeKZ9zXo="},{"num_cand":"U2FsdGVkX1+N/koAO6B8yZImiiYosX7vP+2w/IzIDFM=","cpf":"U2FsdGVkX18dsqWcFMg6CyttIK5Pel3yFCtFzfLjOck="},{"num_cand":"U2FsdGVkX1+Hr3T7dNGOzstRaXJVailHWHiuSe5UcJE=","cpf":"U2FsdGVkX18QjbF0i42bYb6PugM/GopxFELCRO3CtkM="},{"num_cand":"U2FsdGVkX1/M5CYvoHkgtdN9J80MmWbHNb4ht/KjTKE=","cpf":"U2FsdGVkX18RdEH8Tr9ziTL+dqGJz5eQoOvvicPFFxI="},{"num_cand":"U2FsdGVkX19LJuiLTIwU6Ge1wSegNGgfviT0LAQpCrk=","cpf":"U2FsdGVkX1+3a1w/0fERjIUlJgygiR0/29xiqOPdG5w="},{"num_cand":"U2FsdGVkX198NDcLL7IBC307LvvsZeManfaWZi6B6DI=","cpf":"U2FsdGVkX1+xGcsST8djfMLTemULZZKhXHtXE4aq2Cg="},{"num_cand":"U2FsdGVkX18/COEPfByWlPtAfv1NtCsTq7lgxWFteSQ=","cpf":"U2FsdGVkX1+c3fmfNjSkf/jkLc0HU5djKcUH98e9eR4="},{"num_cand":"U2FsdGVkX19Ffx7rNvnDjcCK0MdEGS8rQvb/yn8mNKI=","cpf":"U2FsdGVkX1+US0EsdNuyWWIajHMZLIfeDSZWDBaIlWc="},{"num_cand":"U2FsdGVkX1/KEXfKHUldtcmlngDZwTIuUT4F48QplcE=","cpf":"U2FsdGVkX1+Agt70FvRuPXOF98V6ffQ7ZRDvDb3VMcI="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2210/rec_tit/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
